module.exports = __webpack_public_path__ + "static/media/flow-chart-wap.1b8d1f9a.png";